var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awardContainer",style:(_vm.bgStyle)},[_c('div',{staticClass:"amount"},[_vm._v("\n    "+_vm._s(_vm._f("centToYuan")(_vm.amount))),_c('span',{staticClass:"unit"},[_vm._v("元")])]),_c('span',{staticClass:"preDesc"},[_vm._v("最高")])])
}
var staticRenderFns = []

export { render, staticRenderFns }